/** Xử lý tên người — tách khỏi component để mỗi tệp chỉ xuất một loại thứ. */

/**
 * Chữ cái đại diện cho một người.
 *
 * Lấy chữ cái của TỪ CUỐI, không phải từ đầu: người Việt gọi nhau bằng tên,
 * và tên nằm ở cuối. "Trần Công Khánh" ra "K", không phải "T" — đúng như bản
 * thiết kế vẽ.
 */
export function chuCaiDau(hoTen: string): string {
  const tu = hoTen.trim().split(/\s+/).filter(Boolean)
  return (tu.at(-1)?.charAt(0) ?? '?').toUpperCase()
}
